module.exports = __webpack_public_path__ + "img/به-انتخاب-طراح.d84b1d64.png";